package com.example.positionahead.domain

import com.example.positionahead.model.AssetClass
import com.example.positionahead.model.Position
import com.example.positionahead.model.PositionLot
import com.example.positionahead.model.Quote
import com.example.positionahead.model.TargetHolding
import kotlin.random.Random

/**
 * Builds in-memory (or savable) positions that match dollar targets from the goal planner.
 */
object GoalTargetPortfolioBuilder {

    fun positionsFromTargets(
        targets: List<TargetHolding>,
        quotes: Map<String, Quote>,
    ): List<Position> {
        if (targets.isEmpty()) return emptyList()

        return targets.mapNotNull { target ->
            val symbol = target.symbol.uppercase()
            val price = quotes[symbol]?.price?.takeIf { it > 0 } ?: return@mapNotNull null
            val shares = target.targetMarketValue / price
            if (shares <= 0.0001) return@mapNotNull null

            Position(
                id = Random.nextLong().toString(16),
                symbol = symbol,
                assetClass = MarketSuggestionCatalog.entryFor(symbol)?.assetClass?.let {
                    when (it) {
                        com.example.positionahead.model.DiscoverAssetClass.STOCK -> AssetClass.STOCK
                        com.example.positionahead.model.DiscoverAssetClass.ETF,
                        com.example.positionahead.model.DiscoverAssetClass.MUTUAL_FUND,
                        -> AssetClass.ETF
                        com.example.positionahead.model.DiscoverAssetClass.BOND -> AssetClass.BOND
                    }
                } ?: AssetClass.ETF,
                lots = listOf(
                    PositionLot(
                        id = Random.nextLong().toString(16),
                        shares = shares,
                        costBasisPerShare = price,
                        purchaseDate = "Goal target",
                        note = "Target ${target.targetWeightPercent.format(1)}% weight",
                    ),
                ),
            )
        }
    }

    private fun Double.format(decimals: Int): String {
        val factor = 10.0.pow(decimals)
        return (kotlin.math.round(this * factor) / factor).toString()
    }

    private fun Double.pow(n: Int): Double {
        var result = 1.0
        repeat(n) { result *= 10.0 }
        return result
    }
}
